<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import QuestionAnswer from '/src/components/QuestionAnswer.vue'
import QuestionPage from '/src/components/QuestionPage.vue'
import { MDBBtn} from "mdb-vue-ui-kit";
import { mapFields } from 'vuex-map-fields';

export default {
  components: {
    QuestionAnswer,
    QuestionPage,
    MDBBtn,
  },
  computed: {
    ...mapFields([
      'scene.status.eatout'
    ]),
    ...mapGetters([
      'getQuestionAnswerData'
    ]),
    questionAnswerData() {
      return this.getQuestionAnswerData('eatout')
    }
  },
  methods: {
    ...mapMutations([
      'selectEatoutStatus',
      'goToNextPage',
      'moveToItem'
    ]),
    ...mapActions([
      'goToItem',
    ]),
    chooseBasic: function () {
      this.selectEatoutStatus(1);
      this.eatout = 1
    },
    chooseMedium: function () {
      this.selectEatoutStatus(2);
      this.eatout = 2
    },
    chooseTop: function () {
      this.selectEatoutStatus(3);
      this.eatout = 3
    }
  },
};
</script>
<template>
  <QuestionPage :title="questionAnswerData.question">
    <Transition name="switch" mode="out-in" appear>
      <div v-if="eatout < 2"
        class="question_image question_image_eat-out-basic d-block d-sm-none"
      ></div>
      <div v-else-if="eatout == 2"
        class="question_image question_image_eat-out-medium d-block d-sm-none"
      ></div>
      <div v-else-if="eatout == 3"
        class="question_image question_image_eat-out-top d-block d-sm-none"
      ></div>
    </Transition>

    <!-- show on desktop only -->
    <QuestionAnswer
      :title="questionAnswerData.answers.A"
      class='d-none d-sm-block'
      :onSelect="chooseBasic"
      @click="goToItem('eatout')"
      :imageName="questionAnswerData.images.Q5AA"
    />
    <QuestionAnswer
      :title="questionAnswerData.answers.B"
      class='d-none d-sm-block'
      :onSelect="chooseMedium"
      @click="goToItem('eatout')"
      :imageName="questionAnswerData.images.Q5AB"
    />
    <QuestionAnswer
      :title="questionAnswerData.answers.C"
      class='d-none d-sm-block'
      :onSelect="chooseTop"
      @click="goToItem('eatout')"
      :imageName="questionAnswerData.images.Q5AC"
    />

    <!-- on mobile only -->
    <div class='d-flex d-sm-none questions-on-mobile'>
      <QuestionAnswer
        :title="questionAnswerData.answers.A"
        :isSelected="eatout == 1"
        :onSelect="chooseBasic"
      />
      <QuestionAnswer
        :title="questionAnswerData.answers.B"
        :isSelected="eatout == 2"
        :onSelect="chooseMedium"
      />
      <QuestionAnswer
        :title="questionAnswerData.answers.C"
        :isSelected="eatout == 3"
        :onSelect="chooseTop"
      />
      <MDBBtn class="next-btn-on-mobile" @click="moveToItem('eatout')">next</MDBBtn>
    </div>
  </QuestionPage>
</template>


